import { isLocalApi } from 'utils/localApi';

// Set REACT_APP_LOCAL_API_PROJECT_EMAIL=true in .env.local for the local API.
export const PROJECT_EMAIL_LOCAL_API_REQUESTS = isLocalApi(
  process.env.REACT_APP_LOCAL_API_PROJECT_EMAIL
);
